













































import { Component, Vue, Prop, Watch } from 'nuxt-property-decorator'

export type Service = (
  'web' |
  'mobile' |
  'product-design' |
  'qa-and-testing' |
  'outsourcing' |
  'branding' |
  'ui-ux-design' |
  'seo-sem-sxo' |
  'marketing' |
  'social-media'
)
export type ServiceList = Service[]

@Component<MBriefServices>({})
export default class MBriefServices extends Vue {
  get services() {
    return {
      software: [
        {
          type: 'web',
          name: this.$tc('services.web.name'),
          description: this.$tc('services.web.description'),
          icon: () => import('@/assets/icons/services/web.svg?inline')
        },
        {
          type: 'mobile',
          name: this.$tc('services.mobile.name'),
          description: this.$tc('services.mobile.description'),
          icon: () => import('@/assets/icons/services/mobile.svg?inline')
        },
        {
          type: 'product-design',
          name: this.$tc('services.product-design.name'),
          description: this.$tc('services.product-design.description'),
          icon: () => import('@/assets/icons/services/product-design.svg?inline')
        },
        {
          type: 'qa-and-testing',
          name: this.$tc('services.qa-and-testing.name'),
          description: this.$tc('services.qa-and-testing.description'),
          icon: () => import('@/assets/icons/services/qa-and-testing.svg?inline')
        },
        {
          type: 'outsourcing',
          name: this.$tc('services.outsourcing.name'),
          description: this.$tc('services.outsourcing.description'),
          icon: () => import('@/assets/icons/services/outsourcing.svg?inline')
        },
      ],
      interactive: [
        {
          type: 'branding',
          name: this.$tc('services.branding.name'),
          description: this.$tc('services.branding.description'),
          icon: () => import('@/assets/icons/services/branding.svg?inline')
        },
        {
          type: 'ui-ux-design',
          name: this.$tc('services.ui-ux-design.name'),
          description: this.$tc('services.ui-ux-design.description'),
          icon: () => import('@/assets/icons/services/ui-ux-design.svg?inline')
        },
        {
          type: 'seo-sem-sxo',
          name: this.$tc('services.seo-sem-sxo.name'),
          description: this.$tc('services.seo-sem-sxo.description'),
          icon: () => import('@/assets/icons/services/seo-sem-sxo.svg?inline')
        },
        {
          type: 'marketing',
          name: this.$tc('services.marketing.name'),
          description: this.$tc('services.marketing.description'),
          icon: () => import('@/assets/icons/services/marketing.svg?inline')
        },
        {
          type: 'social-media',
          name: this.$tc('services.social-media.name'),
          description: this.$tc('services.social-media.description'),
          icon: () => import('@/assets/icons/services/social-media.svg?inline')
        }
      ]
    }
  }

  selectedTypes: ServiceList = []

  @Prop({ default: () => [] }) value!: ServiceList

  @Watch('value', { deep: true, immediate: true })
  onValueChange(newValue: ServiceList, oldValue: ServiceList) {
    this.selectedTypes = newValue
  }

  toggleService(type: Service) {
    if (this.selectedTypes.includes(type)) {
      this.selectedTypes.splice(this.selectedTypes.indexOf(type), 1)
    } else {
      this.selectedTypes.push(type)
    }

    this.$emit('input', this.selectedTypes)
  }

  mounted() {
    this.selectedTypes = this.value
  }
}
